/** Max number of eligible listings rendered inside an instant-book group. */
export const INSTANT_BOOK_GROUP_MAX_LISTINGS = 3;

/** Square thumbnail size (px) used for the listing image on each instant-book row. */
export const INSTANT_BOOK_THUMBNAIL_PX = 120;

export const ACTIVATED_STATUS = "ACTIVATED";
